<template>
  <!-- FINDER -->
  <div class="finder">
    <ValidationObserver ref="form" style="display: block">
      <form class="flex" @submit.prevent="onSubmit()">
        <div class="md:w-3/4">
          <div class="flex-wrap mb-10 md:flex">
            <div class="text-2xl md:w-1/3 mb-7 md:mb-0">
              Wybierz lokalizację
            </div>
            <validation-provider rules="required" v-slot="{ errors }" slim>
              <div class="flex flex-wrap md:w-2/3 comparer_location">
                <div
                    class="mx-0 block cursor-pointer w-32 h-36 md:w-[160px] !mb-0 md:h-[160px] bg-white rounded-lg shadow-0-2-5 mr-1.5 relative container"
                >
                  <label class="cursor-pointer inline-block h-full w-full">
                    <input
                        @change="
                        location === 'europe'
                          ? sendEvent({
                              event: 'travelInsuranceCalculator',
                              action: 'Location',
                              label: 'Europa'
                            })
                          : ''
                      "
                        type="radio"
                        value="europe"
                        v-model="location"
                        name="location"
                    />
                    <span class="checkmark"></span>
                    <div
                        class="bg-gray-100 rounded-full w-[70px] h-[70px] mt-5 flex justify-center mx-auto"
                    >
                      <img
                          class="self-center"
                          src="@/assets/img/punkta_comparer/loc-europe.png"
                          alt="icon-europe"
                      />
                    </div>
                    <div class="mt-2 text-sm text-center">Europa</div>

                  </label>
                  <img
                      class="absolute z-[99] left-0 right-0 md:bottom-[22px] bottom-[5px] mx-auto cursor-pointer punkta_comparer_hint "
                      src="@/assets/img/punkta_comparer/icon-info.svg"
                      alt="info"
                  />
                  <div
                      class="md:w-[228%] max-h-[90vh] top-[106%] overflow-y-auto  absolute   w-[200%] z-20 md:p-4 px-[26px] py-[20px] text-sm  bg-white rounded punkta_comparer_hint_popup  shadow-0-2-5"
                  >
                    <div
                        class="md:hidden d-block absolute right-[9px] top-[3px] text-[21px] cursor-pointer close-box"
                    >
                      x
                    </div>
                    Państwa: Albania, Andora, Armenia, Austria, Białoruś,
                    Belgia, Bośnia i Hercegowina, Bułgaria, Chorwacja, Cypr,
                    Czarnogóra, Republika Czeska, Dania, Estonia, Finlandia,
                    Francja (wraz z Korsyką), Niemcy, Gibraltar, Grecja,
                    Węgry, Islandia, Irlandia, Kosowo, Łotwa, Liechtenstein,
                    Litwa, Luksemburg, Macedonia, Malta, Mołdawia, Monako,
                    Holandia, Norwegia, Portugalia, Rumunia, Europejska część
                    Rosji, San Marino, Serbia, Słowacja, Słowenia, Hiszpania,
                    Szwecja, Szwajcaria, Turcja, Ukraina, Wielka Brytania,
                    Watykan, Włochy oraz kraje basenu Morza Śródziemnego:
                    Egipt, Izrael, Liban, Libia, Maroko, Tunezja, z
                    wyłączeniem Polski oraz kraju zamieszkania.
                  </div>
                </div>
                <div
                    class="mx-0 block cursor-pointer w-32 h-36 md:w-[160px] !mb-0 md:h-[160px] bg-white rounded-lg shadow-0-2-5 mr-1.5 relative container"
                >
                  <label class="cursor-pointer inline-block h-full w-full">
                    <input
                        @change="
                        location === 'world'
                          ? sendEvent({
                              event: 'travelInsuranceCalculator',
                              action: 'Location',
                              label: 'Świat'
                            })
                          : ''
                      "
                        type="radio"
                        value="world"
                        v-model="location"
                        name="location"
                    />
                    <span class="checkmark"></span>
                    <div
                        class="bg-gray-100 rounded-full w-[70px] h-[70px] mt-5 flex justify-center mx-auto"
                    >
                      <img
                          class="self-center"
                          src="@/assets/img/punkta_comparer/loc-world.png"
                          alt="icon-world"
                      />
                    </div>
                    <div class="mt-2 text-sm text-center">Świat</div>

                  </label>
                  <img
                      class="absolute z-[99] left-0 md:bottom-[22px] bottom-[5px] right-0 mx-auto cursor-pointer punkta_comparer_hint "
                      src="@/assets/img/punkta_comparer/icon-info.svg"
                      alt="info"
                  />

                  <div
                      class="md:w-[228%] max-h-[90vh] top-[106%] overflow-y-auto  absolute   w-[200%] z-20 md:p-4 px-[26px] py-[20px] md:left-auto left-[-100%] text-sm  bg-white rounded punkta_comparer_hint_popup  shadow-0-2-5"
                  >
                    <div
                        class="md:hidden d-block absolute right-[9px] top-[3px] text-[21px] cursor-pointer close-box"
                    >
                      x
                    </div>
                    Wszystkie państwa świata z wyłączeniem terytorium
                    Afganistanu, Algierii, Iraku, Iranu, Korei Północnej,
                    Sudanu, Sudanu Południowego, Syrii, i kraju zamieszkania
                    Ubezpieczonego.
                  </div>
                </div>
                <div class="w-full pl-1 text-sm text-red-100 error">
                  {{ errors[0] }}
                </div>
              </div>
            </validation-provider>
          </div>

          <div class="mb-10 md:flex">
            <div class="text-2xl md:w-1/3 mb-7 md:mb-0">
              Okres ubezpieczenia
            </div>
            <div class=" md:w-2/3">
              <div class="flex md:w-4/5 w-[86%]">
                <validation-provider
                    name="dateFrom"
                    rules="required|min_date_departure|before:@dateTo|between_data_range:@dateTo"
                    v-slot="{ errors, pristine, touched }"
                    slim
                >
                  <div class="w-1/2 mr-5">
                    <!-- <label class="text-sm mb-2 inline-block" for="date-from"
                    >Data wyjazdu</label
                  > -->
                    <date-picker
                        max="2999-12-31"
                        :disabled-date="disabledRange"
                        @change="
                        dateFrom
                          ? sendEvent({
                              event: 'travelInsuranceCalculator',
                              action: 'Insurance Start Date',
                              label: dateFrom
                            })
                          : ''
                      "
                        lang="pl"
                        placeholder="Data wyjazdu"
                        :clearable="false"
                        format="DD/MM/YYYY"
                        value-type="YYYY-MM-DD"
                        :input-attr="{ name: 'date-from', id: 'date-from' }"
                        :input-class="
                        'w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5 not-italic'
                      "
                        v-model="dateFrom"
                    >
                      <StatusCalendar
                          slot="icon-calendar"
                          :pristine="pristine && !touched"
                          :passed="errors[0] ? false : true"
                      />
                    </date-picker>

                    <div class="mt-4 text-sm text-red-100 error">
                      {{ errors[0] }}
                    </div>
                  </div>
                </validation-provider>
                <validation-provider
                    name="dateTo"
                    rules="required|min_date_departure|after:@dateFrom|between_data_range:@dateFrom"
                    v-slot="{ errors, pristine, touched }"
                    slim
                >
                  <div class="w-1/2">
                    <!-- <label class="text-sm mb-2 inline-block" for="date-to"
                    >Data powrotu</label
                  > -->
                    <!-- <input
                    type="date"
                    @change="
                      $event.target.value
                        ? sendEvent({
                            event: 'travelInsuranceCalculator',
                            action: 'Insurance Return Date',
                            label: $event.target.value
                          })
                        : ''
                    "
                    class="w-full px-5 py-4 mt-2 bg-white rounded shadow-0-2-5"
                    name="date-to"
                    v-model="dateTo"
                    id="date-to"
                  /> -->
                    <date-picker
                        lang="pl"
                        @change="
                        dateTo
                          ? sendEvent({
                              event: 'travelInsuranceCalculator',
                              action: 'Insurance Return Date',
                              label: dateTo
                            })
                          : ''
                      "
                        max="2999-12-31"
                        placeholder="Data powrotu"
                        :disabled-date="disabledRange"
                        :clearable="false"
                        format="DD/MM/YYYY"
                        value-type="YYYY-MM-DD"
                        :input-attr="{ name: 'date-to', id: 'date-to' }"
                        :input-class="
                        'w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5'
                      "
                        v-model="dateTo"
                    >
                      <StatusCalendar
                          slot="icon-calendar"
                          :pristine="pristine && !touched"
                          :passed="errors[0] ? false : true"
                      />
                    </date-picker>
                    <div class="mt-4 text-sm text-red-100 error">
                      {{ errors[0] }}
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div v-if="!$store.state.after7pm && $moment(dateFrom).isSame(new Date(), 'day')">
                   Polisa będzie ważna po 4h od dokonania płatności
                </div>
            </div>
          </div>

          <div class="mb-10 md:flex">
            <div class="text-2xl md:w-1/3 mb-7 md:mb-0">Opcje dodatkowe</div>
            <div class="md:w-2/3 punkta_comparer_options">
              <validation-provider rules="" v-slot="{ errors }" slim>
                <div class="relative md:w-4/5 w-[86%]">
                  <label
                      class="container block p-5 bg-white rounded shadow-0-2-5"
                  >
                    <div class="text-sm">Sporty zimowe</div>
                    <input
                        type="checkbox"
                        name="winterSports"
                        v-model="winterSports"
                        @change="
                        winterSports
                          ? sendEvent({
                              event: 'travelInsuranceCalculator',
                              action: 'Additional Options',
                              label: 'Sporty zimowe'
                            })
                          : ''
                      "
                    />
                    <span class="checkmark"></span>
                  </label>
                  <div class="relative text-sm text-red-100 error">
                    {{ errors[0] }}
                  </div>

                  <img
                      class="absolute transform -translate-y-1/2 cursor-pointer punkta_comparer_hint -right-9 top-1/2"
                      src="@/assets/img/punkta_comparer/icon-info.svg"
                      alt="info"
                  />
                  <div
                      class="md:w-[78%] max-h-[90vh] overflow-y-auto  absolute md:left-[110%] left-0 md:right-auto right-0 w-[91vw] z-20 md:p-4 px-[26px] py-[20px] text-sm transform -translate-y-1/2 bg-white rounded punkta_comparer_hint_popup top-28  md:top-1/2  shadow-0-2-5"
                  >
                    <div
                        class="md:hidden d-block absolute right-[9px] top-[3px] text-[21px] cursor-pointer close-box"
                    >
                      x
                    </div>
                    Sporty zimowe/zimowe dyscypliny sportowe, tj.: hokej,
                    kite-skiing, kite-snowboarding, łyżwiarstwo figurowe,
                    łyżwiarstwo szybkie, narciarstwo biegowe, narciarstwo
                    zjazdowe po oznaczonych trasach, saneczkarstwo, snowboard
                    zjazdowy po oznaczonych trasach, sporty, w których
                    wykorzystywane są pojazdy przeznaczone do poruszania się po
                    śniegu lub lodzie.
                  </div>
                </div>
              </validation-provider>

              <validation-provider rules="" v-slot="{ errors }" slim>
                <div class="relative md:w-4/5 w-[86%]">
                  <label
                      class="container block p-5 bg-white rounded shadow-0-2-5"
                  >
                    <div class="text-sm">Sporty wysokiego ryzyka</div>
                    <input
                        type="checkbox"
                        name="highRiskSports"
                        v-model="highRiskSports"
                        @change="
                        highRiskSports
                          ? sendEvent({
                              event: 'travelInsuranceCalculator',
                              action: 'Additional Options',
                              label: 'Sporty wysokiego ryzyka'
                            })
                          : ''
                      "
                    />
                    <span class="checkmark"></span>
                  </label>
                  <div class="relative text-sm text-red-100 error">
                    {{ errors[0] }}
                  </div>

                  <img
                      class="absolute transform -translate-y-1/2 cursor-pointer punkta_comparer_hint -right-9 top-1/2"
                      src="@/assets/img/punkta_comparer/icon-info.svg"
                      alt="info"
                  />
                  <div
                      class="md:w-[78%] max-h-[90vh] overflow-y-auto  absolute md:left-[110%] left-0 md:right-auto right-0 w-[91vw] z-20 md:p-4 px-[26px] py-[20px] text-sm transform -translate-y-1/2 bg-white rounded punkta_comparer_hint_popup top-28  md:top-1/2  shadow-0-2-5"
                  >
                    <div
                        class="md:hidden d-block absolute right-[9px] top-[3px] text-[21px] cursor-pointer close-box"
                    >
                      x
                    </div>
                    Wyczynowe uprawianie sportów oraz uczestniczenie w wyprawach
                    do miejsc o ekstremalnych warunkach klimatycznych; a także
                    dyscypliny sportowe, których uprawienie wymaga
                    ponadprzeciętnych umiejętności, odwagi i działania w
                    warunkach dużego ryzyka i/lub zawierają elementy akrobacj i
                    aktywność sportowa Ubezpieczonego, której celem jest
                    odpoczynek lub rozrywka, obejmująca uprawianie następujących
                    sportów: baseball, maratony biegowe, biegi długodystansowe,
                    biegi na orientację w terenie, football amerykański,
                    gimnastyka sportowa, gimnastyka akrobatyczna, jazda konna,
                    kitesurfing, krykiet, lekkoatletyka, longboard
                    skateboarding, narty wodne, nurkowanie z aparatem tlenowym
                    poniżej 30 m, polo, jazda quadem, rugby, walki rycerskie,
                    skoki do wody, sporty walki, triathlon, wakeboarding,
                    wioślarstwo, wspinaczka indoorowa, wspinaczka wysokogórska
                    (do 5 500 m n.p.m.), żeglarstwo morskie w pasie przybrzeżnym
                    powyżej 20 mil morskich.
                  </div>
                </div>
              </validation-provider>
              <validation-provider rules="" v-slot="{ errors }" slim>
                <div class="relative md:w-4/5 w-[86%]">
                  <label
                      class="container block p-5 bg-white rounded shadow-0-2-5"
                  >
                    <div class="text-sm">Choroby przewlekłe</div>
                    <input
                        type="checkbox"
                        name="chronicDiseases"
                        v-model="chronicDiseases"
                        @change="
                        chronicDiseases
                          ? sendEvent({
                              event: 'travelInsuranceCalculator',
                              action: 'Additional Options',
                              label: 'Choroby przewlekłe'
                            })
                          : ''
                      "
                    />
                    <span class="checkmark"></span>
                  </label>
                  <div class="relative text-sm text-red-100 error">
                    {{ errors[0] }}
                  </div>

                  <img
                      class="absolute transform -translate-y-1/2 cursor-pointer punkta_comparer_hint -right-9 top-1/2"
                      src="@/assets/img/punkta_comparer/icon-info.svg"
                      alt="info"
                  />
                  <div
                      class="md:w-[78%] max-h-[90vh] overflow-y-auto  absolute md:left-[110%] left-0 md:right-auto right-0 w-[91vw] z-20 md:p-4 px-[26px] py-[20px] text-sm transform -translate-y-1/2 bg-white rounded punkta_comparer_hint_popup top-28  md:top-1/2  shadow-0-2-5"
                  >
                    <div
                        class="md:hidden d-block absolute right-[9px] top-[3px] text-[21px] cursor-pointer close-box"
                    >
                      x
                    </div>
                    Choroby lub problemy zdrowotne wymienione w aktualnie
                    obowiązującej MiędzynarodowejKlasyfikacji Chorób i Problemów
                    Zdrowotnych zdiagnozowaneUbezpieczonego przed zawarciem
                    Umowy ubezpieczenia, które były leczone stale lub okresowo
                    lub były przyczyną Hospitalizacji Ubezpieczonego w okresie
                    24 miesięcy przed zawarciem Umowy ubezpieczenia. Do chorób
                    przewlekłych zalicza się również alergie z wyłączeniem
                    sytuacji gdy reakcja alergiczna wystąpiła nagle i jej
                    konsekwencje zagrażająbezpośredniożyciu Ubezpieczonego.
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="md:flex punkta_comparer_user_data">
            <div class="text-2xl md:w-1/3 mb-7 md:mb-0">
              Dane osoby ubezpieczającej
            </div>
            <div class="md:w-2/3">
              <validation-provider
                  :rules="{
                  required: true,
                  regex: /^[A-Za-ząćęśłńóżźĄĆĘŚŁŃÓŻŹ]+$/
                }"
                  v-slot="{ errors, pristine }"
              >
                <div class="relative md:w-4/5 mb-5">
                  <input
                      class="w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5"
                      type="text"
                      placeholder="Imię"
                      name="clientName"
                      v-model="clientName"
                      @click="
                      sendEvent({
                        event: 'travelInsuranceCalculator',
                        action: 'Field Click',
                        label: '1 Step - Imię'
                      })
                    "
                  />
                  <StatusInput
                      v-if="!pristine || errors[0] ? true : false"
                      :passed="errors[0] ? false : true"
                  />
                </div>

                <div class="relative text-sm text-red-100 error">
                  {{ errors[0] }}
                </div>
              </validation-provider>
              <validation-provider
                  :rules="{
                  required: true,
                  regex: /^[A-Za-ząćęśłńóżźĄĆĘŚŁŃÓŻŹ -]+$/
                }"
                  v-slot="{ errors, pristine }"
              >
                <div class="relative md:w-4/5 mb-5">
                  <input
                      class="w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5"
                      type="text"
                      placeholder="Nazwisko"
                      name="clientSurname"
                      v-model="clientSurname"
                      @click="
                      sendEvent({
                        event: 'travelInsuranceCalculator',
                        action: 'Field Click',
                        label: '1 Step - Nazwisko'
                      })
                    "
                  />
                  <StatusInput
                      v-if="!pristine || errors[0] ? true : false"
                      :passed="errors[0] ? false : true"
                  />
                </div>

                <div class="relative text-sm text-red-100 error">
                  {{ errors[0] }}
                </div>
              </validation-provider>
              <validation-provider
                  :rules="{
                  required: true,
                  max_date_adult: true
                }"
                  v-slot="{ errors, pristine, touched }"
              >
                <!-- <label
                  class="mb-2 text-sm comparer_date inline-block"
                  for="clientDate"
                  >Data Urodzenia</label
                >
                <br /> -->
                <div class="relative md:w-4/5 w-[86%] mb-5">
                  <!-- <input
                    name="clientDate"
                    v-model="clientDate"
                    class="w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5"
                    type="date"
                  /> -->
                  <date-picker
                      lang="pl"
                      @click="
                      sendEvent({
                        event: 'travelInsuranceCalculator',
                        action: 'Field Click',
                        label: '1 Step - Data Urodzenia'
                      })
                    "
                      :default-value="defaultDate"
                      max="2999-12-31"
                      placeholder="Data Urodzenia"
                      :clearable="false"
                      format="DD/MM/YYYY"
                      value-type="YYYY-MM-DD"
                      :input-attr="{ name: 'clientDate', id: 'clientDate' }"
                      :input-class="
                      'w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5 not-italic'
                    "
                      v-model="clientDate"
                  >
                    <StatusCalendar
                        slot="icon-calendar"
                        :pristine="pristine && !touched"
                        :passed="errors[0] ? false : true"
                    />
                  </date-picker>

                  <img
                      class="absolute transform -translate-y-1/2 cursor-pointer punkta_comparer_hint -right-9 top-1/2"
                      src="@/assets/img/punkta_comparer/icon-info.svg"
                      alt="info"
                  />
                  <div
                      class="md:w-[78%] max-h-[90vh] overflow-y-auto  absolute md:left-[110%] left-0 md:right-auto right-0 w-[91vw] z-20 md:p-4 px-[26px] py-[20px] text-sm transform -translate-y-1/2 bg-white rounded punkta_comparer_hint_popup top-28  md:top-1/2  shadow-0-2-5"
                  >
                    <div
                        class="md:hidden d-block absolute right-[9px] top-[3px] text-[21px] cursor-pointer close-box"
                    >
                      x
                    </div>
                    Na podstawie daty urodzenia ubezpieczyciele wyliczają
                    składkę ubezpieczeniową dla każdego uczestnika podróży.
                  </div>
                </div>

                <div class="relative text-sm text-red-100 error">
                  {{ errors[0] }}
                </div>
              </validation-provider>
              <validation-provider
                  :rules="{
                  required: true,
                  regex: /[a-z\d]+[\w\d.-]*@(?:[a-z\d]+[a-z\d-]+\.){1,5}[a-z]{2,6}$/
                }"
                  v-slot="{ errors, pristine }"
              >
                <div class="relative md:w-4/5 w-[86%] mb-5">
                  <input
                      name="clientEmail"
                      v-model="clientEmail"
                      class="w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5"
                      type="email"
                      placeholder="Adres email"
                      @click="
                      sendEvent({
                        event: 'travelInsuranceCalculator',
                        action: 'Field Click',
                        label: '1 Step - Adres email'
                      })
                    "
                  />
                  <StatusInput
                      v-if="!pristine || errors[0] ? true : false"
                      :passed="errors[0] ? false : true"
                  />
                  <img
                      class="absolute transform -translate-y-1/2 cursor-pointer punkta_comparer_hint -right-9 top-1/2"
                      src="@/assets/img/punkta_comparer/icon-info.svg"
                      alt="info"
                  />
                  <div
                      class="md:w-[78%] max-h-[90vh] overflow-y-auto  absolute md:left-[110%] left-0 md:right-auto right-0 w-[91vw] z-20 md:p-4 px-[26px] py-[20px] text-sm transform -translate-y-1/2 bg-white rounded punkta_comparer_hint_popup top-28  md:top-1/2  shadow-0-2-5"
                  >
                    <div
                        class="md:hidden d-block absolute right-[9px] top-[3px] text-[21px] cursor-pointer close-box"
                    >
                      x
                    </div>
                    Na podany adres e-mail wyślemy do Ciebie ogólne warunki
                    ubezpieczenia, kartę produktu ubezpieczeniowego i pozostałe
                    dokumenty związane z zawarciem umowy ubezpieczenia.
                  </div>
                </div>

                <div class="relative text-sm text-red-100 error">
                  {{ errors[0] }}
                </div>
              </validation-provider>

              <validation-provider
                  :rules="{ required: true, numeric: true, min: 9, max: 9 }"
                  v-slot="{ errors, pristine }"
              >
                <div class="relative md:w-4/5 mb-5">
                  <input
                      name="clientPhone"
                      v-model="clientPhone"
                      class="w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5"
                      type="tel"
                      placeholder="Numer Telefonu"
                      @click="
                      sendEvent({
                        event: 'travelInsuranceCalculator',
                        action: 'Field Click',
                        label: '1 Step - Numer Telefonu'
                      })
                    "
                  />
                  <StatusInput
                      v-if="!pristine || errors[0] ? true : false"
                      :passed="errors[0] ? false : true"
                  />
                </div>

                <div class="relative text-sm text-red-100 error">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="mb-10 md:flex punkta_comparer_userbol">
            <div class="md:w-1/3"></div>
            <div class="text-sm md:w-2/3">
              <div
                  class="border-b border-black md:w-4/5 border-opacity-20 pb-11"
              >
                <div class="mb-2">
                  Osoba ubezpieczająca jest uczestnikiem wyjazdu.
                </div>
                <validation-provider rules="" v-slot="{ errors }" slim>
                  <label class="inline-flex cursor-pointer click-box">
                    <div class="switch">
                      <div class="relative right-10">
                        {{ clientTripParticipant ? 'Tak' : 'Nie' }}
                      </div>

                      <input
                          type="checkbox"
                          name="clientTripParticipant"
                          v-model="clientTripParticipant"
                      />

                      <span class="slider round"></span>
                    </div>
                    <div id="error">{{ errors[0] }}</div>
                  </label>
                </validation-provider>
              </div>
            </div>
          </div>

          <div class="mb-10 md:flex punkta_comparer_userbol">
            <div class="md:w-1/3"></div>
            <div class="text-sm md:w-2/3">
              <div class="md:w-4/5 punkta_comparer_acceptances">
                <label class="container flex !mb-8">
                  <input
                      id="checkAll"
                      v-model="check"
                      type="checkbox"
                      v-on:click="checkAll()"
                  />
                  <span class="checkmark"></span>
                  <div class="ml-2 text-sm md:font-bold">
                    Akceptuję wszystkie zgody
                  </div>
                </label>
                <validation-observer ref="terms">
                  <validation-provider
                      class="parent-box"
                      v-for="item in clientTerms"
                      :key="item.code"
                      :rules="{
                      required: item.required ? { allowFalse: false } : false
                    }"
                      v-slot="{ errors }"
                  >
                    <label class="container block mb-4">
                      <input
                          type="checkbox"
                          v-model="clientTermsAccept[item.code]"
                          :name="item.code"
                          v-on:click="checkChilds"
                          :value="false"
                          immediate
                      />

                      <span class="checkmark"></span>
                      <div class="ml-2">
                        <ReadMoreCustom
                            more-str=" (więcej)"
                            :shortText="item.shortText"
                            :longText="item.content"
                            less-str=" (mniej)"
                        ></ReadMoreCustom>
                      </div>
                    </label>
                    <div class="relative pt-1 text-sm text-red-100 error">
                      {{ errors[0] }}
                    </div>
                    <div
                        class="pl-[43px] subcategories-box"
                        v-if="item.subcategories && item.subcategories.length > 0"
                    >
                      <validation-provider
                          v-for="subcategory in item.subcategories"
                          :key="subcategory.code"
                          :rules="{
                          required: subcategory.required
                            ? { allowFalse: false }
                            : false
                        }"
                          v-slot="{ errors }"
                      >
                        <label class="container block mb-4">
                          <input
                              type="checkbox"
                              v-model="clientTermsAccept[subcategory.code]"
                              :name="subcategory.code"
                              v-on:click="checkParent"
                              :value="false"
                              immediate
                          />

                          <span class="checkmark"></span>
                          <div class="ml-2" v-html="subcategory.content"></div>
                        </label>
                        <div class="relative pt-1 text-sm text-red-100 error">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </div>
                  </validation-provider>
                </validation-observer>
              </div>
            </div>
          </div>

          <div class="md:flex">
            <div class="md:w-1/3"></div>
            <div class="md:w-2/3">
              <div class="flex justify-end w-full md:w-4/5">
                <button
                    type="submit"
                    class="flex justify-center w-32 py-4 text-xs font-bold text-white bg-orange-100 rounded-lg comparer-button md:w-40"
                >
                  <div class="mx-1">Dalej</div>
                  <svg
                      class="self-center mx-1"
                      width="15"
                      height="6"
                      viewBox="0 0 15 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M14.9437 2.67401C14.908 2.56895 14.8545 2.47296 14.7862 2.39156L12.9107 0.251722C12.7695 0.0905471 12.5779 0 12.3781 0C12.1783 0 11.9867 0.0905471 11.8455 0.251722C11.7042 0.412898 11.6248 0.631499 11.6248 0.859435C11.6248 1.08737 11.7042 1.30597 11.8455 1.46715L12.4456 2.14334H0.750187C0.551225 2.14334 0.360412 2.23351 0.219725 2.39403C0.0790375 2.55455 0 2.77226 0 2.99927C0 3.22628 0.0790375 3.44399 0.219725 3.6045C0.360412 3.76502 0.551225 3.8552 0.750187 3.8552H12.4456L11.8455 4.53139C11.7751 4.61096 11.7193 4.70563 11.6812 4.80993C11.6432 4.91423 11.6236 5.02611 11.6236 5.1391C11.6236 5.2521 11.6432 5.36397 11.6812 5.46827C11.7193 5.57258 11.7751 5.66724 11.8455 5.74681C11.9152 5.82704 11.9982 5.89072 12.0896 5.93417C12.181 5.97763 12.2791 6 12.3781 6C12.4771 6 12.5752 5.97763 12.6666 5.93417C12.758 5.89072 12.841 5.82704 12.9107 5.74681L14.7862 3.60698C14.8545 3.52558 14.908 3.42959 14.9437 3.32452C15.0188 3.11614 15.0188 2.8824 14.9437 2.67401Z"
                        fill="white"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <Chat/>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import Chat from './Chat.vue'
import StatusInput from './StatusInput.vue'
import ReadMoreCustom from './ReadMoreCustom.vue'
import StatusCalendar from './StatusCalendar.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pl'

export default {
  components: {
    Chat,
    StatusInput,
    ReadMoreCustom,
    DatePicker,
    StatusCalendar
  },
  name: 'Form',
  data() {
    return {
      defaultDate: this.$moment(new Date()).subtract(30, 'years'),
      location: 'europe',
      dateFrom: '',
      dateTo: '',
      winterSports: false,
      highRiskSports: false,
      chronicDiseases: false,
      clientName: '',
      clientSurname: '',
      clientDate: '',
      clientEmail: '',
      clientPhone: '',
      clientTripParticipant: true,
      clientTerms: [
        {
          code: 'term_35',
          required: true,
          shortText: 'Oświadczam, iż zapoznałem/am się z <a class="text-[#0078BE] hover:text-[#0078BE]" target="_blank" href="https://punkta.pl/app/uploads/2025/06/polityka-prywatnosci.pdf">Polityką Prywatności</a> oraz <a target="_blank" class="text-[#0078BE] hover:text-[#0078BE]" href="https://punkta.pl/app/uploads/2025/06/regulamin.pdf">Regulaminem Świadczenia Usług Drogą Elektroniczną</a> serwisu internetowego Punkta, jak również z <a target="_blank" class="text-[#0078BE] hover:text-[#0078BE]" href="https://punkta.pl/app/uploads/2025/06/informacja-o-dystrybutorze.pdf">Klauzulą Informacyjną dystrybutora ubezpieczeń</a> oraz pośrednika kredytowego i  akceptuję ich postanowienia.',
          content: ''
        },
        {
          code: 'term_36',
          required: false,
          shortText: 'Wyrażam zgodę na przetwarzanie przez Punkta Sp. z o.o. moich danych osobowych w celach marketingowych związanych',
          content: ' z korzystaniem z serwisu internetowego www.punkta.pl w zgodzie i według zasad określonych w <a class="text-[#0078BE] hover:text-[#0078BE]" target="_blank" href="https://punkta.pl/regulaminy/">Regulaminach</a>. Mam świadomość tego  że podanie danych osobowych jest dobrowolne  a zgodę mogę w każdej chwili wycofać  zwracając się ze stosownym żądaniem na adres e-mail rodo@punkta.pl. Wycofanie zgody nie wpływa na zgodność z prawem przetwarzania  którego dokonano na podstawie zgody przed jej wycofaniem.'
        },
        {
          code: 'term_37',
          required: false,
          shortText: 'Wyrażam zgodę na otrzymywanie od Punkta Sp. z o.o. informacji handlowych, w tym komunikacji marketingowej (wraz ',
          content: ' z wykorzystaniem telekomunikacyjnych urządzeń końcowych oraz automatycznych systemów wywołujących) dotyczącej produktów i usług Punkta Sp. z o.o.  wybierając następujące kanały kontaktu:',
          subcategories: [
            {
              code: 'term_37_email',
              required: false,
              content: 'E-mail'
            },
            {
              code: 'term_37_sms',
              required: false,
              content: 'SMS'
            },
            {
              code: 'term_37_telefon',
              required: false,
              content: 'Telefon'
            }
          ]
        },
        {
          code: 'term_40',
          required: false,
          shortText: 'Wyrażam zgodę na udostępnienie przez Punkta Sp. z o.o. moich danych osobowych współpracującym Partnerom',
          content: ' biznesowym <a href="//punkta.pl/app/uploads/2025/06/lista-partnerow.pdf" class="text-[#0078BE] hover:text-[#0078BE]" target="_blank">(zgodnie z ich aktualną Listą)</a>  w celu przedstawienia mi przez te podmioty informacji handlowych  w tym komunikacji marketingowej (wraz z wykorzystaniem telekomunikacyjnych urządzeń końcowych oraz automatycznych systemów wywołujących) na podany przeze mnie numer telefonu oraz adres e-mail  w tym na profilowanie i wyświetlanie treści dopasowanych do moich potrzeb.'
        },
        {
          code: 'term_41',
          required: false,
          shortText: 'Żądam przesyłania informacji i zawiadomień wynikających z przepisów prawa na podany przeze mnie adres e-mail.',
          content: ''
        }
      ],
      clientTermsAccept: [],
      clientMarketingAccept: false,
      clientMarketingPhoneAccept: false,
      clientMarketingSmsAccept: false,
      loader: false,
      valid: false,
      check: false
    }
  },
  mounted() {
    this.location = this.$store.state?.location ? this.$store.state?.location : 'europe'
    this.dateFrom = this.$store.state?.dateFrom
    this.dateTo = this.$store.state?.dateTo
    this.winterSports = this.$store.state?.winterSports
    this.highRiskSports = this.$store.state?.highRiskSports
    this.chronicDiseases = this.$store.state?.chronicDiseases
    this.clientName = this.$store.state?.clientName
    this.clientSurname = this.$store.state?.clientSurname
    this.clientDate = this.$store.state?.clientDate
    this.clientEmail = this.$store.state?.clientEmail
    this.clientPhone = this.$store.state?.clientPhone
    this.clientTripParticipant = this.$store.state?.clientTripParticipant
    this.check = this.$store.state?.check

    this.checkTime()

    if (this.$store.state.clientTermsAccept.length > 0) {
      this.$store.state.clientTermsAccept.forEach(element => {
        this.clientTermsAccept[element.code] = element.check
        if (element.subcategories && element.subcategories.length > 0) {
          element.subcategories.forEach(subcategory => {
            this.clientTermsAccept[subcategory.code] = subcategory.check
          })
        }
      })
    } else {
      this.clientTerms.forEach(element => {
        this.clientTermsAccept[element.code] = element.check
            ? element.check
            : false
        if (element.subcategories && element.subcategories.length > 0) {
          element.subcategories.forEach(subcategory => {
            this.clientTermsAccept[subcategory.code] = subcategory.check
                ? subcategory.check
                : false
          })
        }
      })
    }

    this.getPartners()
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'travelInsuranceCalculator',
      action: 'Step Enter',
      label: '1'
    })
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate().then(success => {
        if (!success) {

          const errors = Object.entries(this.$refs.form.errors)
          .map(([key, value]) => ({ key, value }))
          .filter(error => error["value"].length);
          if(this.$refs.form.refs[errors[0]["key"]]){
            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
            behavior: "smooth",
            block: "start"
            });
          }

          return
        }
        let tmpclientTermsAccept = []

        this.clientTerms.forEach(element => {
          let tmpclientTermsAcceptSubcategories = []
          if (element.subcategories && element.subcategories.length > 0) {
            element.subcategories.forEach(subcategory => {
              tmpclientTermsAcceptSubcategories.push({
                code: subcategory.code,
                content: subcategory.content,
                check: this.clientTermsAccept[subcategory.code] ? true : false
              })
            })
          }
          tmpclientTermsAccept.push({
            code: element.code,
            content: element.shortText.replace(/<[^>]*>?/gm, '') + element.content.replace(/<[^>]*>?/gm, ''),
            subcategories: tmpclientTermsAcceptSubcategories,
            check: this.clientTermsAccept[element.code] ? true : false
          })
        })

        this.$store.commit('setLocation', this.location)
        this.$store.commit('setDateFrom', this.dateFrom)
        this.$store.commit('setDateTo', this.dateTo)
        this.$store.commit('setWinterSports', this.winterSports)
        this.$store.commit('setHighRiskSports', this.highRiskSports)
        this.$store.commit('setChronicDiseases', this.chronicDiseases)
        this.$store.commit('setClientName', this.clientName)
        this.$store.commit('setClientSurname', this.clientSurname)
        this.$store.commit(
            'setClientDate',
            this.clientTripParticipant ? this.clientDate : ''
        )
        this.$store.commit('setClientEmail', this.clientEmail)
        this.$store.commit('setClientPhone', this.clientPhone)
        this.$store.commit(
            'setClientTripParticipant',
            this.clientTripParticipant
        )
        this.$store.commit('setClientTermsAccept', tmpclientTermsAccept)
        this.$store.commit('setCheck', this.check)
        if (this.$store.state.leadSalesforceId) {
          this.updateLead()
        } else {
          this.createLead()
        }

        this.sendEmail()
        this.$router.push('form-step-2')
      })
    },
    sendEmail() {
      let _this = this
      this.axios
          .post('/wp-json/travel/v1/sendEmail', {
            event_name: 'travel_service_documents',
            receiver: _this.$store.state.clientEmail
          })
          .catch(function (error) {
            console.log(error)
            _this.$store.commit('setShowModal', true)
          })
    },
    onInputTel(number, phoneObject) {
      if (!this.valid && number.length > 0) {
        this.valid = true
      }
      this.clientPhone = phoneObject // Your validation and variable here
    },
    checkChilds(event) {
      let parent = event.target.closest('.parent-box')
      let parentCode = event.target.name
      parent
          .querySelectorAll('.subcategories-box input')
          .forEach(subcategory => {
            let childCode = subcategory.getAttribute('name')
            if (
                this.clientTermsAccept['' + childCode] !=
                !this.clientTermsAccept['' + parentCode]
            ) {
              this.clientTermsAccept['' + childCode] = !this.clientTermsAccept[
              '' + parentCode
                  ]
              subcategory.checked = this.clientTermsAccept['' + childCode]
            }
          })
    },
    checkParent(event) {
      let parent = event.target.closest('.parent-box')

      let parentCode = parent.firstChild
          .querySelector(' input')
          .getAttribute('name')
      let code = event.target.getAttribute('name')

      if (
          !this.clientTermsAccept['' + code] &&
          !this.clientTermsAccept['' + parentCode]
      ) {
        this.clientTermsAccept['' + parentCode] = !this.clientTermsAccept[
        '' + parentCode
            ]
        parent.firstChild.querySelector(
            ' input'
        ).checked = this.clientTermsAccept['' + parentCode]
      }
    },
    checkTime(){
      let d = new Date()
      let hour = d.getHours()
      if(hour >= 19){
        this.$store.commit('setAfter7pm', true)
      }
    },
    checkAll() {
      let _this = this
      this.check = !this.check

      this.clientTerms.forEach(function (term) {
        _this.clientTermsAccept['' + term.code] = _this.check

        if (term.subcategories && term.subcategories.length > 0) {
          term.subcategories.forEach(subcategory => {
            _this.clientTermsAccept['' + subcategory.code] = _this.check
          })
        }
      })
      // await this.$refs.terms.validate()
    },
    getParam(name, url = window.location.href) {
      name = name.replace(/[[\]]/g, '\\$&');
      let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), decoded_url = decodeURIComponent(url), param;
      try {
        param = regex.exec(decoded_url)[2].split('?');
        if (!param || !param[0]) return false;
      } catch (e) {
        return false;
      }
      return decodeURIComponent(param[0].replace(/\+/g, ' '));
    },
    updateLead() {
      let protection_scopes = []
      let partners = {}

      if (this.winterSports) {
        protection_scopes.push('winter_sports')
      }
      if (this.highRiskSports) {
        protection_scopes.push('high_risk_sports')
      }
      if (this.chronicDiseases) {
        protection_scopes.push('chronic_diseases')
      }
      partners = Object.fromEntries(this.$store.state.partners.map(partner => [partner + '_agreement', this.termIsChecked('term_40')]))
      let _this = this
      let data = {
        terms: _this.$store.state.clientTermsAccept,
        lead: {
          salesforce_id: _this.$store.state.leadSalesforceId,
          source: 'travel',
          company:
            _this.clientName +
            '_' +
            _this.clientSurname +
            '_' +
            _this.clientPhone +
            '_' +
            _this.clientEmail,
          product_scope:
            _this.location == 'europe' ? 'TRAVEL_EUROPE' : 'TRAVEL_WORLD',
          protection_scopes:
            protection_scopes.length > 1
              ? protection_scopes.join(';')
              : protection_scopes.join(''),
          email: _this.clientEmail,
          phone: _this.clientPhone,
          policy_start_date: _this
            .$moment(_this.dateFrom)
            .format('YYYY-MM-DD'),
          policy_end_date: _this.$moment(_this.dateTo).format('YYYY-MM-DD'),
          first_name: _this.clientName,
          last_name: _this.clientSurname,
          own_phone_agreement: _this.termIsChecked('term_37_telefon'),
          own_sms_agreement: _this.termIsChecked('term_37_sms'),
          own_email_agreement: _this.termIsChecked('term_37_email'),
          partners_phone_agreement: _this.termIsChecked('term_40'),
          partners_sms_agreement: _this.termIsChecked('term_40'),
          partners_email_agreement: _this.termIsChecked('term_40'),
          complaint_email_agreement: _this.termIsChecked('term_41'),
          rodo_agreement: _this.termIsChecked('term_36'),
          birthdate: _this.clientTripParticipant ? _this.clientDate : '',
          ...partners
        }
      }
      if(this.getParam('utm_campaign')) data.lead.utm_campaign = this.getParam('utm_campaign')
      if(this.getParam('utm_medium')) data.lead.utm_medium = this.getParam('utm_medium')
      if(this.getParam('utm_source')) data.lead.utm_source = this.getParam('utm_source')
      if(this.getParam('utm_content')) data.lead.utm_content = this.getParam('utm_content')
      if(this.getParam('mpc')) data.lead.mpc = this.getParam('mpc')


      this.axios
          .post('/wp-json/travel/v1/updateLead', data)
          .catch(function (error) {
            console.log(error)
            // _this.$store.commit('setShowModal', true)
          })
    },
    createLead() {
      let protection_scopes = []
      let partners = {}

      if (this.winterSports) {
        protection_scopes.push('winter_sports')
      }
      if (this.highRiskSports) {
        protection_scopes.push('high_risk_sports')
      }
      if (this.chronicDiseases) {
        protection_scopes.push('chronic_diseases')
      }
      partners = Object.fromEntries(this.$store.state.partners.map(partner => [partner + '_agreement', this.termIsChecked('term_40')]))

      let _this = this
      let data = {
        terms: _this.$store.state.clientTermsAccept,
        lead: {
          source: 'travel',
          company:
            _this.clientName +
            '_' +
            _this.clientSurname +
            '_' +
            _this.clientPhone +
            '_' +
            _this.clientEmail,
          product_scope:
            _this.location == 'europe' ? 'TRAVEL_EUROPE' : 'TRAVEL_WORLD',
          protection_scopes:
            protection_scopes.length > 1
              ? protection_scopes.join(';')
              : protection_scopes.join(''),
          email: _this.clientEmail,
          phone: _this.clientPhone,
          policy_start_date: _this
            .$moment(_this.dateFrom)
            .format('YYYY-MM-DD'),
          policy_end_date: _this.$moment(_this.dateTo).format('YYYY-MM-DD'),
          first_name: _this.clientName,
          last_name: _this.clientSurname,
          own_phone_agreement: _this.termIsChecked('term_37_telefon'),
          own_sms_agreement: _this.termIsChecked('term_37_sms'),
          own_email_agreement: _this.termIsChecked('term_37_email'),
          partners_phone_agreement: _this.termIsChecked('term_40'),
          partners_sms_agreement: _this.termIsChecked('term_40'),
          partners_email_agreement: _this.termIsChecked('term_40'),
          complaint_email_agreement: _this.termIsChecked('term_41'),
          rodo_agreement: _this.termIsChecked('term_36'),
          birthdate: _this.clientTripParticipant ? _this.clientDate : '',
          ...partners
        }
      }

      if(this.getParam('utm_campaign')) data.lead.utm_campaign = this.getParam('utm_campaign')
      if(this.getParam('utm_medium')) data.lead.utm_medium = this.getParam('utm_medium')
      if(this.getParam('utm_source')) data.lead.utm_source = this.getParam('utm_source')
      if(this.getParam('utm_content')) data.lead.utm_content = this.getParam('utm_content')
      if(this.getParam('mpc')) data.lead.mpc = this.getParam('mpc')

      this.axios
          .post('/wp-json/travel/v1/createLead', data)
          .then(function (response) {
            if (response && response.data && response.data.success) {
              _this.$store.commit(
                  'setLeadSalesforceId',
                  response.data.salesforceId
              )
            }
          })
          .catch(function (error) {
            console.log(error)
            // _this.$store.commit('setShowModal', true)
          })
    },
    convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? '0' + s : s
      }

      var d = new Date(inputFormat)
      return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join(
          '/'
      )
    },
    termIsChecked(code) {
      var status = false
      this.$store.state.clientTermsAccept.forEach(element => {
        if (element.code == code && element.check) {
          status = true
        }
        if (element.subcategories && element.subcategories.length > 0) {
          element.subcategories.forEach(subcategory => {
            if (subcategory.code == code && subcategory.check) {
              status = true
            }
          })
        }
      })
      return status
    },
    sendEvent(value) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(value)
    },
    disabledRange: function (date) {
      let d = new Date()
      d.setHours(0, 0, 0, 0)
      if(this.$store.state.after7pm){
        return date <= d;
      }
      return date < d;
    },
    getPartners(){
      let _this = this
      this.axios.get('/wp-json/travel/v1/getAgreementPartners')
      .then(function (response) {
        if (response && response.data && response.data.success) {
          _this.$store.commit(
              'setPartners',
             response.data.partners
          )
        }
      })
      .catch(function (error) {
        console.log(error)
        // _this.$store.commit('setShowModal', true)
      })
    }
  }
}
</script>
